import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/education/pages/publicEducationPage.tsx");
